<template>
  <div class="list-comment-cell-root">
    <div
      :class="[displayContent == null || displayContent === '' ? 'data-table-list-comment nocomment' : 'data-table-list-comment']"
      @click="activeComment()"
      v-if="!input_show"
    >
      <pre v-html="formattedContent" class="data-table-list-comment-pre" style="margin: 0"></pre>
    </div>
    <div style="display: flex; align-items: center" v-if="input_show">
      <textarea
        v-if="!isNumericOnly"
        v-model="value"
        class="comment-textarea"
        :rows="textarea_rows"
        :id="inputId"
        :maxlength="listCommentMaxContentLength"
        @keydown.enter.ctrl.exact="saveComment()"
        @keydown.enter.meta.exact="saveComment()"
        @change="comment_on ? '' : saveComment()"
        @blur="comment_on ? '' : saveComment()"
      ></textarea>
      <el-input
        v-else
        v-model="value"
        :id="inputId"
        @keypress.enter.native="saveComment()"
        @change="comment_on ? '' : saveComment()"
        @blur="comment_on ? '' : saveComment()"
      ></el-input>
    </div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const updateCommentValueAPI = root + "/api/list/update_comment_value";
import {
  isValidListCommentContentLength,
  LIST_COMMENT_MAX_CONTENT_LENGTH,
  LIST_COMMENT_MAX_CONTENT_LENGTH_MESSAGE,
} from "@/utils/listCommentConst";

export default {
  name: "listCommentCell",
  props: ["column", "content", "list_id", "sns_type", "influencer_id", "index"],
  data() {
    return {
      input_show: false,
      comment_on: false,
      comment_before: "",
      value: "",
      listCommentMaxContentLength: LIST_COMMENT_MAX_CONTENT_LENGTH,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    permission() {
      return this.$store.state.permission.list.edit;
    },
    isNumericOnly() {
      return String(this.column.is_numeric_only) === "1";
    },
    displayContent() {
      return this.content;
    },
    inputId() {
      return "comment_cell_" + this.column.column_id + "_" + this.influencer_id;
    },
    textarea_rows() {
      if (this.value) {
        var num = this.value.match(/\r\n|\n/g);
        return num && num.length > 6 ? 7 : num && num.length > 3 ? num.length : 3;
      }
      return 3;
    },
    formattedContent() {
      const value = this.displayContent;
      const url_regexp = /https?:\/\/[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#\u3000-\u30FE\u4E00-\u9FA0\uFF01-\uFFE3]+/g;
      if (value == null || value === "") {
        return this.isNumericOnly ? "数値を入力" : "コメントを入力できます";
      }
      return String(value).replace(url_regexp, (url) => '<a class="router-link" href="' + url + '" target="_blank">' + url + "</a>");
    },
  },
  methods: {
    activeComment() {
      if (!this.permission) {
        this.$store.dispatch("openUnpermittedDrawer", true);
        return;
      }
      this.input_show = true;
      this.comment_before = this.displayContent;
      this.value = this.displayContent == null ? "" : this.displayContent;
      setTimeout(() => {
        const el = document.getElementById(this.inputId);
        if (el) el.focus();
      }, 50);
    },
    saveComment() {
      if (!this.permission) {
        return;
      }
      this.comment_on = true;

      if (this.isNumericOnly && this.value !== "" && !/^\d{1,9}(\.\d{1,2})?$/.test(this.value)) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "整数部9桁・小数第2位までの数値を入力してください",
        });
        this.value = this.comment_before;
        setTimeout(() => {
          this.comment_on = false;
        }, 300);
        return;
      }

      if (!this.isNumericOnly && !isValidListCommentContentLength(this.value)) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: LIST_COMMENT_MAX_CONTENT_LENGTH_MESSAGE,
        });
        this.value = this.comment_before;
        setTimeout(() => {
          this.comment_on = false;
        }, 300);
        return;
      }

      if (this.comment_before == this.value) {
        this.input_show = false;
        setTimeout(() => {
          this.comment_on = false;
        }, 300);
        return;
      }

      this.input_show = false;
      var params = new URLSearchParams();
      params.append("list_id", this.list_id);
      params.append("column_id", this.column.column_id);
      params.append("influencer", this.influencer_id);
      params.append("sns_type", this.sns_type);
      params.append("content", this.value);
      params.append("token", this.token);
      this.axios
        .post(updateCommentValueAPI, params)
        .then((response) => {
          if (response.data.status === "OK") {
            this.$emit("syncComment", this.index, this.value, this.column.column_id);
            this.$message({
              type: "success",
              offset: 7,
              showClose: true,
              message: "コメントを更新しました",
            });
          } else {
            this.value = this.comment_before;
            this.input_show = true;
            this.$message({
              type: "error",
              offset: 7,
              showClose: true,
              message: response.data.message || "コメントの更新に失敗しました",
            });
          }
        })
        .catch(() => {
          this.value = this.comment_before;
          this.input_show = true;
          this.$message({
            type: "error",
            offset: 7,
            showClose: true,
            message: "コメントの更新に失敗しました",
          });
        })
        .finally(() => {
          setTimeout(() => {
            this.comment_on = false;
          }, 300);
        });
    },
  },
};
</script>

<style scoped>
.list-comment-cell-root {
  width: 100%;
  box-sizing: border-box;
}
</style>
